import { motion } from '@qdz/element';

// Reveal on scroll: sections and grid items below the first screen fade in as they enter the viewport.
// Anything already on screen at load is shown at once, so nothing flashes. Off with reduced motion,
// in the theme editor, or when Theme settings > Motion > Reveal on scroll is None.
const SECTIONS = 'main .shopify-section > .qdz-section:not([data-reveal-off])';
const ITEMS = '.qdz-product-grid > li, .qdz-row > *';
const MAX_STAGGER = 6;

const root = document.documentElement;
const style = motion.style('reveal');

if (style && style !== 'none' && !motion.reduced && !window.Shopify?.designMode && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.setAttribute('data-revealed', '');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px' }
  );

  const seen = new WeakSet();
  const prepare = (scope) => {
    const fold = window.innerHeight;
    for (const element of scope.querySelectorAll(`${SECTIONS}, ${ITEMS}`)) {
      if (seen.has(element) || element.hasAttribute('data-revealed')) continue;
      seen.add(element);
      element.setAttribute('data-reveal', '');
      if (element.getBoundingClientRect().top < fold) {
        element.setAttribute('data-revealed', '');
        continue;
      }
      if (element.matches(ITEMS)) {
        const index = [...element.parentElement.children].indexOf(element) % MAX_STAGGER;
        element.style.setProperty('--qdz-reveal-index', index);
      }
      observer.observe(element);
    }
  };

  root.setAttribute('data-reveal-ready', '');
  prepare(document);
  new MutationObserver((records) => {
    const scopes = new Set();
    for (const record of records) {
      for (const node of record.addedNodes) if (node instanceof Element) scopes.add(node.parentElement ?? document);
    }
    for (const scope of scopes) prepare(scope);
  }).observe(document.querySelector('main') ?? document.body, { childList: true, subtree: true });
}
